import Icon from '../components/Icon.vue'

Icon.register({
  tv: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M592 0c26.5 0 48 21.5 48 48v320c0 26.5-21.5 48-48 48h-234.9v32h160c17.7 0 32 14.3 32 32s-14.3 32-32 32h-384c-17.7 0-32-14.3-32-32s14.3-32 32-32h160v-32h-245.1c-26.5 0-48-21.5-48-48v-320c0-26.5 21.5-48 48-48h544zM576 352v-288h-512v288h512z'
      }
    ]
  }
})
